/* eslint-disable no-param-reassign */
import { Datetime } from 'vue-datetime';
import 'vue-datetime/dist/vue-datetime.css';

import Vue from 'vue';
import VueOffline from 'vue-offline';

// import * as Sentry from '@sentry/browser';
// import { Vue as VueIntegration } from '@sentry/integrations';
// import { Integrations } from '@sentry/tracing';

import Analytics from 'analytics';
import googleTagManager from '@analytics/google-tag-manager';
import moment from 'moment';
import router from './app/app-routes';
import App from './app/app.vue';
import VueBbob from '@bbob/vue2';
import { store } from '@/app/shared/stores/store';
import { formatToLocal } from './filters/formatDate';
import i18n from '@/i18n';


Vue.prototype.moment = moment;
Vue.filter('formatToLocal', formatToLocal);
Vue.use(VueBbob);

if (process.env.NODE_ENV === 'production' && process.env.VUE_APP_ENV !== 'cordova') {
  Analytics({
    app: 'XVIII The Grove',
    plugins: [
      googleTagManager({
        containerId: 'GTM-NXZPXJ',
      }),
    ],
  });
}

Vue.config.productionTip = false;

// if (process.env.NODE_ENV === 'production') {
//   Sentry.init({
//     dsn: 'https://99790a5220174711b56042d17197c0fd@o467145.ingest.sentry.io/5493058',
//     integrations: [
//       new VueIntegration({
//         Vue,
//         tracing: true,
//       }),
//       new Integrations.BrowserTracing(),
//     ],

//     // We recommend adjusting this value in production, or using tracesSampler
//     // for finer control
//     tracesSampleRate: 1.0,
//     sampleRate: 1.0,
//     captureUnhandledRejections: true,
//   });
// }

Vue.prototype.$isStandard = process.env.VUE_APP_PMG_ENV === 'Standard';
Vue.prototype.$isMobileApp = process.env.VUE_APP_ENV === 'cordova';
Vue.prototype.$isMobile = Vue.observable({
  value: process.env.VUE_APP_ENV === 'cordova' || window.innerWidth < 924,
});
Vue.prototype.$isIOS = process.env.VUE_APP_ENV === 'cordova' && process.env.VUE_APP_CORDOVA_PLATFORM === 'ios';

Vue.use(require('vue-moment'));

Vue.directive('local-img', {
  // When the bound element is inserted into the DOM...
  inserted: (el, binding) => {
    if (binding.value.includes('https://')) {
      el.src = binding;
    } else {
      el.src = `${process.env.VUE_APP_BASE_URL}img/${binding.value}`;
    }
  },
});

Vue.directive('local-img-bg', {
  // When the bound element is inserted into the DOM...
  inserted: (el, binding) => {
    const backgroundText = binding.value.match(/(?=url\().*?(?=\))/);
    backgroundText[0] = backgroundText[0].replace('"', '');
    backgroundText[0] = backgroundText[0].replace('url(', '');
    const backgroundTextToUse = binding.value.replace(
      backgroundText[0],
      `"${process.env.VUE_APP_BASE_URL}img/${backgroundText[0]}"`,
    );
    const cssToUse = `background-image: ${backgroundTextToUse}`;
    el.style.cssText += cssToUse;
  },
});

Vue.use(Datetime);

// To-do: no need to inject into every component
// https://www.npmjs.com/package/vue-offline
Vue.use(VueOffline);

const vue = new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
});

// if ('serviceWorker' in navigator) {
//   window.addEventListener('load', () => {
//     navigator.serviceWorker.register('/sw.js').then((registration) => {
//       console.log('SW registered: ', registration);
//     }).catch((registrationError) => {
//       console.log('SW registration failed: ', registrationError);
//     });
//   });
// }

vue.$mount('#app');
